var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEvisitDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon e-visit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-e-visit"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#181E34",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,1.5 C22.4142136,1.5 22.7892136,1.66789322 23.0606602,1.93933983 C23.3321068,2.21078644 23.5,2.58578644 23.5,3 L23.5,3 L23.5,17 C23.5,17.4142136 23.3321068,17.7892136 23.0606602,18.0606602 C22.7892136,18.3321068 22.4142136,18.5 22,18.5 L22,18.5 L2,18.5 C1.58578644,18.5 1.21078644,18.3321068 0.939339828,18.0606602 C0.667893219,17.7892136 0.5,17.4142136 0.5,17 L0.5,17 L0.5,3 C0.5,2.58578644 0.667893219,2.21078644 0.939339828,1.93933983 C1.21078644,1.66789322 1.58578644,1.5 2,1.5 L2,1.5 Z",
    id: "Rectangle",
    stroke: "#181E34",
    strokeOpacity: 0.400000006
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(8.000852, 3.000000)",
    fill: "#181E34",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96191338,0 C4.6415714,0 5.57602979,0.160522363 6.16814657,0.925346111 C6.52387919,1.38501234 6.65067978,1.93851941 6.65067978,2.30325396 C6.65067978,2.39052174 6.62940835,2.73458614 6.59608786,3.07523814 C6.58178318,3.22132776 6.56799243,3.34017417 6.55474419,3.43728754 C6.63456189,3.43693296 6.71327593,3.45555301 6.78413305,3.49155019 C7.03916184,3.62029814 7.15659729,3.93096583 7.07642254,4.26470913 C6.92740829,4.88229648 6.55540089,5.34842388 6.15058693,5.45569053 C6.10584554,5.7882311 5.94232674,6.47378662 5.34684079,6.91594336 L5.34684079,6.91594336 L5.59878594,7.47160415 C5.62702413,7.48058266 6.16814657,7.63509138 6.21959775,7.63509138 C6.80696379,7.79747251 7.44608369,7.95585417 7.9987848,8.20426736 C7.00373925,9.30847225 5.5756648,10 3.98920656,10 C2.41385256,10 0.994672932,9.31811892 -1.01424424e-12,8.22799388 C0.561623129,7.95911188 1.20162245,7.78570687 1.75773595,7.63509138 C1.97901597,7.57517869 2.18801852,7.51811899 2.37811947,7.45994047 L2.37811947,7.45994047 L2.6468819,6.89242022 C2.07823508,6.44964813 1.91231789,5.77956027 1.86454996,5.45636182 C1.45890799,5.35007414 1.08584415,4.88355515 0.936601478,4.26482102 C0.858882224,3.942154 0.971121161,3.63822719 1.21592825,3.50861216 C1.2771682,3.47580807 1.34468957,3.45580728 1.4142237,3.44987424 C1.33738956,3.17296687 1.26303948,2.83830054 1.21946873,2.6303403 C1.21718455,2.62290017 1.21578548,2.61783752 1.21532865,2.61615929 C1.21259296,2.60561443 1.21075927,2.59486454 1.20984661,2.58402125 C1.19282947,2.50159236 1.18217947,2.44637871 1.18040923,2.4346591 C1.13195605,2.11062153 1.23965517,1.42478631 1.735094,0.86313985 C2.36438583,0.149753743 3.29339074,0 3.96191338,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L24,14 L24,17 C24,18.1045695 23.1045695,19 22,19 L2,19 C0.8954305,19 1.3527075e-16,18.1045695 0,17 L0,14 L0,14 Z",
    id: "Rectangle-Copy",
    fill: "#181E34",
    opacity: 0.400000006
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,20.5 C13.9348303,20.5 14.7840737,20.8664825 15.4118469,21.4636543 C15.9238785,21.9507264 16.2886967,22.5912207 16.4323521,23.3115002 L16.4323521,23.3115002 L7.53701023,23.4891741 C7.64844846,22.7271147 8.00545971,22.0447928 8.52512627,21.5251263 C9.15850169,20.8917508 10.0335017,20.5 11,20.5 L11,20.5 Z",
    id: "Rectangle-Copy-2",
    stroke: "#181E34",
    strokeOpacity: 0.400000006
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvisitDark);
export default __webpack_public_path__ + "static/media/icon-evisit_dark.930cd45f3560effbdec000926b77630a.svg";
export { ForwardRef as ReactComponent };